/* tslint:disable */
/* eslint-disable */

/**
 * Transactional email type, also used as the TMS event type.
 */
export enum CustomEmailType {
  OrderDeliveryConfirmation = 'ORDER_DELIVERY_CONFIRMATION',
  OrderPickupConfirmation = 'ORDER_PICKUP_CONFIRMATION',
  OrderDeliveryReceipt = 'ORDER_DELIVERY_RECEIPT',
  OrderPickupReceipt = 'ORDER_PICKUP_RECEIPT',
  OrderRefunded = 'ORDER_REFUNDED',
  OrderFailed = 'ORDER_FAILED',
  ScheduledOrderPlacedForPickup = 'SCHEDULED_ORDER_PLACED_FOR_PICKUP',
  ScheduledOrderPlacedForDelivery = 'SCHEDULED_ORDER_PLACED_FOR_DELIVERY',
  ScheduleOrderPickupConfirmation = 'SCHEDULE_ORDER_PICKUP_CONFIRMATION',
  ScheduleOrderDeliveryConfirmation = 'SCHEDULE_ORDER_DELIVERY_CONFIRMATION',
  ScheduleOrderDeliveryReceipt = 'SCHEDULE_ORDER_DELIVERY_RECEIPT',
  ScheduleOrderPickupReceipt = 'SCHEDULE_ORDER_PICKUP_RECEIPT',
  ScheduledOrderCanceled = 'SCHEDULED_ORDER_CANCELED',
  PrivacyWebpageVerification = 'PRIVACY_WEBPAGE_VERIFICATION',
  AbandonedDeliveryCart = 'ABANDONED_DELIVERY_CART',
  AbandonedPickupCart = 'ABANDONED_PICKUP_CART',
  GroupOrderInvitation = 'GROUP_ORDER_INVITATION',
  GroupOrderInviteeDeliveryConfirmation = 'GROUP_ORDER_INVITEE_DELIVERY_CONFIRMATION',
  GroupOrderInviteePickupConfirmation = 'GROUP_ORDER_INVITEE_PICKUP_CONFIRMATION',
  GroupOrderInviteeOrderCancellation = 'GROUP_ORDER_INVITEE_ORDER_CANCELLATION',
  GroupOrderOwnerDeliveryConfirmation = 'GROUP_ORDER_OWNER_DELIVERY_CONFIRMATION',
  GroupOrderOwnerPickupConfirmation = 'GROUP_ORDER_OWNER_PICKUP_CONFIRMATION',
}
